import React from "react";
import { SuccessTick } from "icons/auth/SuccessTick";
import { useNavigate, useParams } from "react-router-dom";

const AssistanceRequest = () => {
  const { clusterId } = useParams();
  const navigate = useNavigate();
  return (
    <div className="w-full h-full grid place-items-center">
      <div className="flex items-center justify-center lg:h-full flex-col text-center p-5 max-w-[630px]">
        <SuccessTick />
        <div className="text-2xl my-10">Payment assistance request submitted successfully</div>
       <div className="w-full text-center bg-bgThird lg:py-5 py-4 lg:px-10 px-5 lg:text-lg text-base text-txtParagraph break-words mb-4 font-normal">
         Our team will contact you shortly to discuss available options.
        </div>

        <div
          className="mt-10 lg:text-base text-sm cursor-pointer text-blue hover:!text-btnPrimaryHover"
          onClick={() => navigate(`/${clusterId}/dashboard`)}
        >
          Back to dashboard
        </div>
      </div>
    </div>
  );
};

export default AssistanceRequest;
